import * as _ from 'underscore';
import { Keys } from '../helpers/Keys';
import { Module } from '../Module';

_.each(_.filter(<any>Keys, _.isString), (key: string) => {
  Module.instance().directive('tb' + key, <any[]>[
    () => {
      return {
        link: (scope: ng.IScope, element: JQuery, attrs: any) => {
          element.on('keydown', (event: JQuery.Event) => {
            if (event.which === (<any>Keys)[key]) {
              scope.$apply(() => {
                scope.$eval(attrs['tb' + key], { $event: event });
              });
            }
          });
        }
      };
    }
  ]);
});
